// shared variables for the src/helpers/ory/utils/ directory

interface FlexibleDictionary {
	[key: string]: string | undefined;
}

export const inputLabelMapping: FlexibleDictionary = {
	"E-Mail": "Email",
};
